import React, {useState} from "react";
import styles from './index.module.scss';
import { encrypt } from "@src/utils/RsaUtil";
import { login } from "@src/services/Login";

//导入antd
import { Form, Input, Button,message } from 'antd';
import { useNavigate } from "react-router-dom";
// 导入react-redux
import { useDispatch } from "react-redux";
import { saveUserInfo } from "@src/store/actions/user";

//登录组件
export const Login = (props: any) => {
    const {form, loginPath, setLoginModalVisible } = props;

    const [loading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    //存储用户信息
    const setUserInfo = (res: any) => {
        // 使用redux存储用户信息
        dispatch(saveUserInfo(res.data));
    }

    //清空表单
    const clearForm = () => {
        form.resetFields();
    }

    const handleSubmit = (e: any) => {
        e.preventDefault();
        const validateFields = ['account', 'password'];
        form.validateFields(validateFields).then((values: any) => {
            setLoading(true);
            const { account, password } = values;
            const params = {
                account,
                password: encrypt(password),
            }
            login(params)
                .then(setUserInfo)
                .then(() => {
                        //登录成功后，提示用户登录成功,提示只持续1.5s，并跳转到首页
                        message.success('登录成功', 1);
                        clearForm();
                        setLoading(false);
                        setLoginModalVisible(false);
                        navigate(loginPath);
                    })
                .catch((err: any) => {
                    //登录失败后，提示用户登录失败
                    setLoading(false);
                })
        })
    }


    return (
        <div className={styles.login}>
            <div className={styles.login_c}>
                <div className={styles.login_c_title}>登录</div>
                <div className={styles.login_c_form}>
                    <Form 
                        className={styles.login_c_form}
                        name="login"
                        form={form}
                        validateTrigger="onBlur"
                    >
                        <Form.Item
                            name="account"
                            rules={[{ required: true, message: '请输入手机号' }]}
                            className={styles.login_c_form_item}
                        >
                            <Input
                                className={styles.login_c_form_item_input} 
                                placeholder="请输入手机号" 
                                prefix={<img src={require('@src/assets/imgs/login/username.png').default} alt=""/>}
                            />
                        </Form.Item>
                        <Form.Item
                            name="password"
                            rules={[{ required: true, message: '请输入密码' }]}
                            className={styles.login_c_form_item}
                        >
                            <Input.Password 
                            className={styles.login_c_form_item_input} 
                            placeholder="请输入密码" 
                            prefix={<img src={require('@src/assets/imgs/login/password.png').default} alt=""/>}
                            />
                        </Form.Item>
                        <Form.Item className={styles.login_c_form_item}>
                            <Button type="primary" 
                                htmlType="submit" 
                                className={styles.login_c_form_btn} 
                                onClick={handleSubmit}
                                loading={loading}
                            >
                                登录
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>
    )
}